import { render, staticRenderFns } from "./regulatoryData.vue?vue&type=template&id=9183bd02"
import script from "./regulatoryData.vue?vue&type=script&lang=js"
export * from "./regulatoryData.vue?vue&type=script&lang=js"
import style0 from "./regulatoryData.vue?vue&type=style&index=0&id=9183bd02&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports